module.exports = __webpack_public_path__ + "static/media/pilates.b2078583.jpg";